// extracted by mini-css-extract-plugin
module.exports = {"block":"block-94f867","title":"title-94f867","ratio":"ratio-94f867","img":"img-94f867","link":"link-94f867"};